<template>
  <div class="baseLayoutContent">
    <sidebar></sidebar>
    <div class="mainWidth">
      <div class="content">
        <router-view></router-view>
      </div>
      <footer class="mainFooter">
        <div class="footerContent">
          <span class="footerRightText">{{ versionText }}</span>
          <span class="footerRightText">Powered by Vasion Automate</span>
        </div>
      </footer>
    </div>
  </div>
</template>

<script>
import Sidebar from './Sidebar.vue'
import { getVersionText } from '@/utils/version.js'

export default {
  components: {
    // Navbar,
    Sidebar,
  },
  computed: {
    versionText() {
      return getVersionText()
    },
  },
}
</script>

<style scoped>
.baseLayoutContent {
  min-height: 100vh;
  display: flex;
}

.mainWidth {
  width: 100%;
  margin-left: 155px;
  background-color: var(--secondary-color);
  padding-left: 31px;
  padding-right: 41px;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

.content {
  flex: 1;
  z-index: 1;
}

.footerText {
  color: var(--primary-color);
  font-family: Archivo;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 175%; /* 21px */
  text-align: right;
  margin-top: 5px;
  margin-right: 20px;
}

.footerLeftText {
  color: var(--primary-color);
  font-family: Archivo;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 175%;
  text-align: left;
}

.footerContent {
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin-top: 5px;
}

.mainFooter {
  width: 100%;
  text-align: right;
  margin-top: auto;
  margin-bottom: 10px;
  z-index: 0;
}
</style>
